import React from 'react';

import {
  IconButton,
  InputAdornment,
  useTheme,
} from '@mui/material';

interface IAdornmentIconButton {
  disabled?: boolean;
  Icon: React.ElementType;
  iconProps?: Record<string, unknown>;
  onSubmit?: () => void;
}

export const AdornmentIconButton: React.FC<IAdornmentIconButton> = (props) => {
  const { disabled, Icon, iconProps, onSubmit } = props;

  const { palette } = useTheme();

  return (
    <InputAdornment position="end">
      <IconButton
        disabled={disabled}
        sx={{ background: palette.background.paper }}
        onClick={onSubmit}
        size="small"
      >
        <Icon sx={{ fontSize: 16, ...iconProps }} />
      </IconButton>
    </InputAdornment>
  );
};
